import { render, staticRenderFns } from "./NewFriend.vue?vue&type=template&id=16b661bd"
import script from "./NewFriend.vue?vue&type=script&lang=js"
export * from "./NewFriend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports